module.exports = __webpack_public_path__ + "static/screenshot_mixed_1-152f499f764e36b95914fac1d02f73fb.png";